import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import CloseModalButton from 'components/global/Constant/CloseModalButton';

const MESSAGES = {
  withdrawOne:
    'Remove this application from the batch? Loan Tracking will add Removed from Batch (Completed) for this application.',
  resetAll:
    'Reset this entire batch? Every application will be removed and receive Removed from Batch (Completed) on Loan Tracking.',
};

const TITLES = {
  withdrawOne: 'Remove from Batch',
  resetAll: 'Reset Batch (All Applications)',
};

/**
 * Confirms batch removal / reset-all with optional note (Loan Tracking event + application note).
 * @param {object} props
 * @param {boolean} props.show
 * @param {'withdrawOne'|'resetAll'} props.variant
 * @param {() => void} props.onHide
 * @param {(note: string) => Promise<void>} props.onConfirm — receives trimmed note (may be empty)
 * @param {boolean} props.busy
 */
export default function LoanBatchRemovalNoteModal({ show, variant, onHide, onConfirm, busy }) {
  const [note, setNote] = useState('');

  useEffect(() => {
    if (show) setNote('');
  }, [show, variant]);

  const message = MESSAGES[variant];
  const title = TITLES[variant];

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onConfirm(note.trim());
  };

  const handleClose = () => {
    if (!busy) onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered backdrop={busy ? 'static' : true} keyboard={!busy}>
      <Modal.Header className="d-flex align-items-center justify-content-between">
        <Modal.Title className="mb-0 pr-8">{title}</Modal.Title>
        <span className={busy ? 'pointer-events-none opacity-50' : ''}>
          <CloseModalButton onCloseModal={handleClose} />
        </span>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <p className="mb-16">{message}</p>
          <Form.Group controlId="loan-batch-removal-note" className="mb-0">
            <Form.Label>Note (optional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={note}
              onChange={(e) => setNote(e.target.value)}
              disabled={busy}
              placeholder="Add a note for Loan Tracking and the application record…"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" type="button" onClick={handleClose} disabled={busy}>
            Cancel
          </Button>
          <Button variant="danger" type="submit" disabled={busy}>
            {busy ? 'Working…' : title}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
